import React, {Component} from 'react'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import Single from '../../../componentes/Single'
import MoverHerramienta from './MoverHerramienta'
import { AuthContext } from '../../../Auth'

export default class Empleados extends Component{
    constructor(props){
        super(props)
        this.app= firebase;
        this.state={
            almacenes: [],
            datos:[],
            filtro:'Todos',
            alert:"",
            loading: false
        }
    }
    componentDidMount() {
        this.getAlmacenes()
        this.getData()
    }
    componentDidUpdate(prevProps, prevState){
        if(this.state.filtro!==prevState.filtro){
            this.getData()
        }
    }
    setReference=()=>{
        let dbReference=firebase.firestore().collection('InventarioH')
        if (!this.state.filtro)  {return dbReference}
        dbReference=this.filtro(dbReference)
        return dbReference
    }
    filtro=dbReference=>{
        if (this.state.filtro === "Todos"){return dbReference}
        return dbReference.where('ubicacion', '==', this.state.filtro)   
    }
    handlefiltroChange=(e, {value})=>{
        this.setState({filtro:value})
    }
    getAlmacenes= async()=>{
        const docRef = this.app.firestore().collection('Info').doc('info');
        docRef.get().then((doc) => {
            if (doc.exists) {
                this.setState({ almacenes: doc.data().almacenes })
            } else {
                console.log('No such document!');
            }
        }).catch((error) => {
            console.log('Error getting document:', error);
        });
    }
    getData= async ()=>{
        try {
            const snapshot = await this.setReference().get();
            const items = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            const groupedData = items.reduce((list, item) => {
                if (!this.state.almacenes.includes(item.ubicacion)) {
                    if (!list[item.ubicacion]) {
                    list[item.ubicacion] = [];
                }
                list[item.ubicacion].push({
                    id: item.id,
                    herramienta: item.herramienta,
                    fecha:item.fecha.toDate().toLocaleDateString(),
                });
            }
            return list;
        }, {});
        this.setState({
            datos:groupedData,
            loading: false
        })
      } catch (error) {
        console.error("Error fetching data: ", error);
        this.setState({loading: false})
      }
    }
    render(){
        return(
            <section>
                <div className="filtro">
                    Buscar Empleado
                    <Single tabla='Empleados' columna='Nombre'
                    filtro1='activo' filtro2='==' filtro3='si' 
                    value={this.state.filtro} onChange={this.handlefiltroChange}
                    incluir={["Todos"]}
                    placeholder='nombre' />
                </div>
                {Object.entries(this.state.datos).map(([employee, herramientas]) => {
                    return <Employee 
                        employee={employee} 
                        herramientas={herramientas} 
                        key={employee}
                        actualizar={this.getData}
                    />
                })}
            </section>
        )
    }
}
class Employee extends React.Component {
    static contextType = AuthContext
    constructor(props) {
        super(props)
        this.state = {
            tableVisible: false,
            employee: this.props.employee,
            herramientas: this.props.herramientas
        }
    }
    toggleTable = () => {
        this.setState({
            tableVisible: !this.state.tableVisible
        })
    }
    admin =(row)=>{
        if (this.context.currentUser.rol === "admin" || this.context.currentUser.rol === "warehouseAdmin"){
            return(
                <MoverHerramienta
                    data={row}
                    pasadoPor={this.context.currentUser.name}
                    actualizar={this.props.actualizar}
                />
            )
        }
    }
    renderHerramientas = (herramientas) => {
        return (
            <>
            <div className="tabla">
                <table><tbody>
                        <tr>
                            <th>Herramienta</th>
                            <th>Fecha</th>
                        </tr>
                        {herramientas.map((activity, key) =>
                            <tr key={key}>
                                <td>{activity.herramienta}</td>
                                <td>{activity.fecha}</td>
                                <td>{this.admin(activity)}</td>
                            </tr>
                        )}
                </tbody></table>
                </div>
            </>
        )
    }
    
    render() {
        return (
            <div>
                <div className="divrowH" onClick={this.toggleTable}>
                    <p>{`${this.state.employee}`}</p>
                </div>
                {
                    this.state.tableVisible
                        ? this.state.herramientas.length > 0
                            ? this.renderHerramientas(this.state.herramientas)
                            : null
                        : null
                }
            </div>
        )
    }
}